import { render, staticRenderFns } from "./OrderTicketDialog.vue?vue&type=template&id=789d47aa&scoped=true"
import script from "./OrderTicketDialog.vue?vue&type=script&lang=js"
export * from "./OrderTicketDialog.vue?vue&type=script&lang=js"
import style0 from "./OrderTicketDialog.vue?vue&type=style&index=0&id=789d47aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "789d47aa",
  null
  
)

export default component.exports